import React, {
  FC,
} from 'react';
import { FaChevronLeft } from 'react-icons/fa6';
import RowBetween from '../../../../../../../components/Layout/RowBetween';
import SquadSemiBoldText from '../../../../../../../components/Text/SquadSemiBoldText';
import Button from '../../../../../../../components/Button';
import PingFangMediumText from '../../../../../../../components/Text/PingFangMediumText';

const Title: FC<Props> = ({
  onClose,
  isEnglish,
}) => {
  return (
    <RowBetween style={{ marginTop: '20px', alignItems: 'center' }}>
      {/* 返回箭头 */}
      <Button
        style={{ marginLeft: '15px', marginTop: '-15px' }}
        onClick={() => {
          if (onClose) {
            onClose();
          }
        }}
      >
        <FaChevronLeft style={{ fontSize: '20px', marginTop: '7px', color: '#11202B' }} />
      </Button>
      {
        isEnglish ? (
          <SquadSemiBoldText fontSize={26} lineHeight={30}>
            Search for recipient
          </SquadSemiBoldText>
        ) : (
          <PingFangMediumText fontSize={26} lineHeight={30}>搜索收件人</PingFangMediumText>
        )
      }
      {/* 用于和左侧返回箭头配合布局 */}
      <Button
        style={{ marginRight: '15px', marginTop: '-15px', opacity: 0 }}
      >
        <FaChevronLeft style={{ fontSize: '20px', marginTop: '7px', color: '#11202B' }} />
      </Button>
    </RowBetween>
  );
};

export interface Props {
  onClose?: () => void;
  isEnglish: boolean;
}

export default Title;
